import { addToRecord, updateRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { CampaignLoadFulfilledAction } from '../../domains/campaigns/actions.types';
import {
  PinCampaignObjectFulfilledAction,
  PinCampaignObjectRejectedAction,
  UnpinCampaignObjectFulfilledAction,
} from '../../domains/pinnedResources/actions.types';
import { pendingPinnedObjectEdgeId } from '../../domains/pinnedResources/types';
import { Campaign } from '../types';

import { CampaignPinnedResources } from './types';

export type CampaignPinnedResourceAction =
  | CampaignLoadFulfilledAction
  | PinCampaignObjectFulfilledAction
  | PinCampaignObjectRejectedAction
  | UnpinCampaignObjectFulfilledAction;

const initialState: CampaignPinnedResources = {};

const stateWithFulfilledCampaignPinnedResources = (
  state: CampaignPinnedResources,
  { id, entities }: CampaignLoadFulfilledAction['payload']
): CampaignPinnedResources => addToRecord(state, id, entities.campaignPinnedResources[id]);

const removePinnedObjectFromPinnedResourcesState = (
  state: CampaignPinnedResources,
  { campaignId, unpinnedObjectEdgeId }: UnpinCampaignObjectFulfilledAction['payload']
): CampaignPinnedResources =>
  updateRecord(state, campaignId, {
    id: campaignId,
    pinnedResources: state[campaignId].pinnedResources.filter((resource) => resource.edgeId !== unpinnedObjectEdgeId),
  });

const removePendingPinnedObjectsFromPinnedResourcesState = (
  state: CampaignPinnedResources,
  campaignId: Campaign['id']
): CampaignPinnedResources =>
  updateRecord(state, campaignId, {
    id: campaignId,
    pinnedResources: state[campaignId].pinnedResources.filter(
      (resource) => resource.edgeId !== pendingPinnedObjectEdgeId
    ),
  });

const addPinnedObjectToPinnedResourcesState = (
  state: CampaignPinnedResources,
  { campaignId, edgeId, result: node }: PinCampaignObjectFulfilledAction['payload']
): CampaignPinnedResources => {
  const pinnedResources = [...state[campaignId].pinnedResources, { edgeId, node }];

  return updateRecord(state, campaignId, {
    id: campaignId,
    pinnedResources,
  });
};
const reducer: Reducer<CampaignPinnedResources, CampaignPinnedResourceAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN.LOAD_FULFILLED':
      return stateWithFulfilledCampaignPinnedResources(state, action.payload);
    case 'CAMPAIGN_PINNED_RESOURCES.PIN_OBJECT_FULFILLED':
      return addPinnedObjectToPinnedResourcesState(state, action.payload);
    case 'CAMPAIGN_PINNED_RESOURCES.PIN_OBJECT_REJECTED':
      return removePendingPinnedObjectsFromPinnedResourcesState(state, action.payload.campaignId);
    case 'CAMPAIGN_PINNED_RESOURCES.UNPIN_OBJECT_FULFILLED':
      return removePinnedObjectFromPinnedResourcesState(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
